import ModuleClientReporting from 'mfClientReporting/ClientReporting';

/**
 * Re-export of the client reporting module, allowing for mocks
 * (the promise based alias 'mfClientReporting/*' can't be mocked directly) to be used in tests
 */
export { ModuleClientReporting };
